export default {
  title: {
    add: 'Aggiungi script',
    update: 'Aggiorna script',
  },
  form: {
    strategy: {
      label: 'Strategia',
      placeholder: 'Seleziona strategia',
    },
    source: {
      label: 'Sorgente (src)',
      placeholder: 'Inserisci sorgente',
    },
    async: {
      label: 'Asincrono',
      placeholder: 'Seleziona asincrono',
    },
    content: {
      label: 'Contenuto',
      placeholder: 'Inserisci contenuto',
    },
  },
  alert: {
    use_case: "Caso d'uso",
  },
  buttons: {
    save: 'Salva',
  },
};
